import {LANG_KEY} from "../../../../constants";
import {Col, DatePicker, Form, FormProps, Input, Row, Select} from "antd";
import {StyledOrder} from "../../../../pages/Entrant/AdmissionView/index.styles";
import {selectStore} from "../../../../store/selector";
import {useSelector} from "react-redux";
import {FormInstance} from "antd/es/form/hooks/useForm";
import {memo} from "react";
import {useSearchParams} from "react-router-dom";

interface Type {
  lang: LANG_KEY | string,
  form: FormInstance,
  order: any
}

const FORM_NAME = {
  number: 'number',
  basis_ru: 'basis_ru',
  basis_kk: 'basis_kk',
  date: 'date',
  subadmin: 'subadmin',
}

const rules = [
  {
    required: true,
    message: 'Введите!',
  },
]

type IType = 'edit' | 'view' | 'create' | null | string

const SEARCH_PARAMS = {
  TYPE: 'type'
}

export const UserLeaveNote = memo(({lang, form, order}: Type) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const {
    admission: {
      userOrder: userOrderState,
      groupList: groupListState,
    }
  } = useSelector(selectStore)

  const type: IType = searchParams.get(SEARCH_PARAMS.TYPE);


  return (
    <StyledOrder>
      <span className="lang">{lang === LANG_KEY.RU ? "Русский" : "Казахский"}</span>
      <div className="content">
        <Row>
          <Col flex="0 0 500px" style={{display: "flex", justifyContent: "space-between"}} span={24}>

            <span style={{width: "45%", display: "flex", alignItems: "center"}}>
                №
              <Form.Item name={FORM_NAME.number} rules={rules}>
                <Input className="br" style={{width: "100%", margin: "0 0 0 6px"}}/>
              </Form.Item>
            </span>

            <Form.Item name={FORM_NAME.date} rules={rules}>
              <DatePicker className="br"  suffixIcon={false} disabled={type === "edit" || type === "view"}/>
            </Form.Item>

          </Col>
          <Col span={24}>
            <span style={{fontWeight: 700}}>{lang === "ru" ? "О об академичиском отпуске" : "Оқуға қабылдау туралы"}</span>
          </Col>
          <Col span={24}>
            <span style={{fontWeight: 700}}>{lang === "ru" ? "ПРИКАЗЫВАЮ:" : "БҰЙЫРАМЫН"}</span>
          </Col>
          <Col span={24}>
            {lang === "ru" ?
              <span>1. Обучающегося группы {order?.group?.label} {order?.user?.label} по причине академического отпуска исключить из списка обучающегося. </span>
              :
              <span>1. <span>{order?.group?.label}</span> топ білім алушысы <span
                className="b">{order?.user?.label}</span> академиялық демалыс себебі бойынша білім алушылар тізімінен шығарылсын</span>}

          </Col>
          <Col span={24}>
            {lang === "ru" ? (
                <span style={{display: 'inline-flex', alignItems: 'center'}}>2. Исполнение данного приказа возложить на заместителя по учебной части

             <Form.Item name={[FORM_NAME.subadmin, 'id']} style={{marginBottom: 0}}>
                  <Select className="br" options={groupListState.data?.reception?.teachers?.map((item: any) => ({
                    key: item.id,
                    label: item.fio,
                    value: item.id
                  }))} style={{minWidth: 150, maxWidth: 150}}/>
                </Form.Item>
            </span>

              ) :
              (

                <span>  <span style={{display: 'inline-flex'}}>

                  2. Осы бұйрықтың орындалуын бақылау директордың оқу ісі жөніндегі орынбасары
                <Form.Item name={[FORM_NAME.subadmin, 'id']} style={{marginBottom: 0}}>
                    <Select className="br" options={groupListState.data?.reception?.teachers?.map((item: any) => ({
                      key: item.id,
                      label: item.fio,
                      value: item.id,
                    }))} style={{minWidth: 150, maxWidth: 150}}/>
                </Form.Item>
                  жүктелсін
              </span>

            </span>
              )
            }

          </Col>

          {lang === "ru" ?
            <Col span={24} style={{display: "flex", alignItems: "center"}}>
              <span style={{fontWeight: 700}}>Основание:</span>
              <Form.Item name={FORM_NAME.basis_ru}  rules={rules} style={{width: '100%'}}>
                <Input className="br"/>
              </Form.Item>
            </Col>
            :
            <Col span={24} style={{display: "flex", alignItems: "center"}}>
              <span style={{fontWeight: 700}}>Негіздеме:</span>
              <Form.Item name={FORM_NAME.basis_kk}  rules={rules} style={{width: '100%'}}>
                <Input className="br"/>
              </Form.Item>
            </Col>
          }
        </Row>
      </div>

      <div className="footer">
        <span>{lang === "ru" ? "Начальник" : "Бастық"}</span>
        <span>{order?.admin?.label}</span>
      </div>
    </StyledOrder>
  )
})